<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/acquisition.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-8">
                <h4 class="primary-color font-600">
                  {{ $t("text.cDrystock.sales.details.title") }}
                  {{ $route.query.branchName }}
                  <!-- {{startDate ? startDate.split("T")[0] : ""}}  -->
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.cDrystock.sales.details.desc") }}.
                </p>
              </div>
              <div class="col-md-4 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.cDrystock.sales.totalSales") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/acquisition.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ salesCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-banner mt-3">
          <div>
            <div>
              <span class="deep-grey bold-span invoice-header">{{
                $t("text.cDrystock.sales.totalSoldPrice")
              }}</span>
            </div>
            <div class="">
              <span
                ><span class="currency"></span
                ><span class="amount-figures"
                  >{{ convertThousand(totalSoldPrice) }} </span
                ><span class="grey-text bold-span">{{
                  company ? company.currency : ""
                }}</span></span
              >
            </div>
            <div class="grey-text"></div>
          </div>
          <div class="price_change_input_wrapper w-25">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="YYYY-MM-DDTHH:mm:ss"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.selectDate')"
            />
          </div>
          <div>
            <div>
              <span class="deep-grey bold-span invoice-header">{{
                $t("text.cDrystock.sales.totalQtnSold")
              }}</span>
            </div>
            <div>
              <span class="currency"></span
              ><span class="amount-figures">{{ totalQuantitySold }} </span>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="nonWetProductName"
                  :headerText="$t('text.cDrystock.branchStock.product')"
                ></e-column>
                <e-column
                  width="150"
                  field="productCategoryName"
                  :headerText="$t('text.cDrystock.product.category')"
                ></e-column>
                <e-column
                  width="150"
                  field="quantitySold"
                  :headerText="$t('text.cDrystock.branchStock.qtnSold')"
                ></e-column>
                <e-column
                  width="150"
                  field="totalSoldPrice"
                  :headerText="$t('text.cDrystock.supplies.totalPrice')"
                  format="N2"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
    <AddOldUserModal :company="company" :users="users" />
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import CompanyUsersTemplate from "@/components/TableTemplates/companyUsers";
import template from "@/components/Templates/companySalesDetails";
import AddOldUserModal from "@/components/modals/addOldUser";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Non Wet Products Sales :: Epump Portal",
  name: "NonWetProductSales",
  components: {
    MasterLayout,
    TableLoader,
    AddOldUserModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      dateRange: {
        start: this.$moment().subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss"),
        end: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().format(this.$route.query.date),
      formattedStartDate: null,
      company: null,
      backgroundUrl,
      salesCount: 0,
      cardBackgroundUrl,
      showLoader: true,
      users: [],
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      totalSoldPrice: 0,
      totalQuantitySold: 0,
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getSaleDetails();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.getSaleDetails();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getSaleDetails();
    }
  },
  mounted() {
    this.dateRange = JSON.parse(this.$route.query.dateRange);
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    openModal($modal) {
      this.$modal.show($modal);
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Vehicles.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    rowDataBound: function (args) {
      if (args.data["status"] === "Active") {
        args.row.cells[4].style.color = "green";
      }
      if (args.data["status"] === "Deactivated") {
        args.row.cells[4].style.color = "blue";
      }
      if (args.data["status"] === "Suspended") {
        args.row.cells[4].style.color = "red";
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getSaleDetails() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/NonWetProductSales/Sales/BranchDaySales/Detail/${this.$route.query.branchId}?startDate=${this.dateRange.start}&endDate=${this.dateRange.end}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.salesCount = response.data.length;
          this.totalSoldPrice = response.data.reduce(
            (acc, cur) => (acc += cur.totalSoldPrice),
            0
          );
          this.totalQuantitySold = response.data.reduce(
            (acc, cur) => (acc += cur.quantitySold),
            0
          );
          response.data.forEach((el, i) => {
            el.index = i + 1;
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
